import { render, staticRenderFns } from "./FormImage.vue?vue&type=template&id=3e73d2ac"
import script from "./FormImage.ts?vue&type=script&lang=ts"
export * from "./FormImage.ts?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.0.10@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports